import React, { useCallback, useEffect, useState } from "react";
import { FileText, RefreshCw, Receipt, Trash2 } from "lucide-react";
import { euro, practiceApi } from "../../lib/practiceApi";
import { InvoiceDraftDialog } from "./InvoiceDraftDialog";
import { usePager } from "../../lib/usePager";
import { Pager } from "../table/Pager";

export const InvoiceDrafts = ({ onChanged = () => {} }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  const [dialog, setDialog] = useState(null);

  const load = useCallback(async () => {
    try { setData(await practiceApi("/billing/drafts?status=da_preparare&recurring_only=true")); }
    catch (err) { setError(err.message); }
  }, []);
  useEffect(() => { practiceApi("/billing/drafts/refresh", { method: "POST" }).catch(() => {}).then(load); }, [load]);

  async function refresh() {
    setBusy("refresh"); setError("");
    try { await practiceApi("/billing/drafts/refresh", { method: "POST" }); await load(); }
    catch (err) { setError(err.message); } finally { setBusy(""); }
  }


  async function discard(id) {
    setBusy(id);
    try { await practiceApi(`/billing/drafts/${id}`, { method: "DELETE" }); await load(); }
    catch (err) { setError(err.message); } finally { setBusy(""); }
  }

  const rows = data?.rows || [];
  const pager = usePager(rows, 10);
  return <section className="receivables-card" data-testid="invoice-drafts">
    <header>
      <div>
        <span className="finance-kicker"><FileText size={13} />FATTURE DA PREPARARE</span>
        <h2>Canoni delle consulenze ricorrenti</h2>
      </div>
      <button className="icon-btn" title="Ricalcola quote maturate" disabled={busy === "refresh"} data-testid="drafts-refresh" onClick={refresh}><RefreshCw size={14} /></button>
    </header>
    {error && <div className="error" role="alert" data-testid="drafts-error">{error}</div>}
    <div className="receivables-total" data-testid="drafts-total">
      <span>{rows.length} bozze in attesa di emissione</span><strong>{euro(data?.amount || 0)}</strong>
    </div>
    <div className="data-table">
      <div className="table-head" style={{ gridTemplateColumns: "1.2fr 1.6fr .8fr .8fr 190px" }}>
        <span>committente</span><span>prestazione</span><span>maturata il</span><span>importo</span><span>azioni</span>
      </div>
      {pager.visible.map((row, index) => <div className="table-row" key={row.id} data-testid={`draft-${index}`} style={{ gridTemplateColumns: "1.2fr 1.6fr .8fr .8fr 190px" }}>
        <span><strong>{row.client_name || "—"}</strong><small className="receivables-practices">{row.client_vat || row.client_fiscal_code || ""}</small></span>
        <span>{row.description}<small className="receivables-practices">{row.origin === "ricorrente" ? "contratto ricorrente" : row.practice_name}</small></span>
        <span>{(row.matured_on || "").split("-").reverse().join("/")}</span>
        <span>{euro(row.amount)}</span>
        <span style={{ display: "flex", gap: 6 }}>
          <button className="primary sollecito" disabled={busy === row.id} data-testid={`draft-invoice-${index}`}
            onClick={() => setDialog(row)}>
            <Receipt size={12} />Prepara fattura
          </button>
          <button className="icon-btn" title="Scarta la bozza" disabled={busy === row.id} data-testid={`draft-discard-${index}`} onClick={() => discard(row.id)}><Trash2 size={14} /></button>
        </span>
      </div>)}
      {!rows.length && <p className="muted" data-testid="drafts-empty">Nessun canone maturato da preparare.</p>}
    </div>

    {!!pager.total && <Pager pager={pager} label="canoni" testId="recurring-drafts-pager" />}
    {dialog && <InvoiceDraftDialog draft={dialog} onClose={() => setDialog(null)} onConfirmed={async () => { await load(); onChanged(); }} />}
  </section>;
};
